import React from 'react';
import { Popup } from "../Popup";
import PopupStructure from "../PopupStructure";
import { ButtonGroup } from "../ButtonGroup";
import { Button } from "../Button";
import PopupTitleDangerous from "../PopupTitleDangerous";
import { PopupPopupInfoProps } from './PopupInfo.interface';
import styles from './PopupInfo.module.css';

export const PopupInfo: React.FC<PopupPopupInfoProps> = ({
    title,
    message,
    confirmButtonText,
    cancelButtonText,
    maxWidth = "400px",
    onConfirm,
    onCancel,
    isShow = true
}) => (
    <Popup onClose={onCancel} maxWidth={maxWidth} isShow={isShow}>
        <PopupStructure
            headerComponent={
                <PopupTitleDangerous>
                    {title}
                </PopupTitleDangerous>
            }
            contentComponent={
                <div className={styles["popup-info__content"]}>{message}</div>
            }
            footerComponent={
                <ButtonGroup>
                    <Button kind="secondary" onClick={onCancel}>
                        {cancelButtonText}
                    </Button>
                    <Button kind="primary" onClick={onConfirm}>
                        {confirmButtonText}
                    </Button>
                </ButtonGroup>
            }
        />
    </Popup>
);